let copyDelta;
let headingDelta;
let homeCopy;
let homeHeading;
let headerType;
let nav;
let navLogo;
let universityLinkHeaderFour;
let universityLink;
let pricingLink;
let deltaScreenY;

function handleScroll() {
  if (window.scrollY <= copyDelta) {
    if (homeCopy) {
      if (headerType === '2' || headerType === '3' || headerType === '5') {
        homeCopy.style.top = `${-Math.abs(window.scrollY)}px`;
      } else {
        homeCopy.classList.remove('active');
      }
    }
  } else if (homeCopy) {
    if (headerType === '2' || headerType === '3' || headerType === '5') {
      homeCopy.style.top = `${-Math.abs(window.scrollY)}px`;
    } else {
      homeCopy.classList.add('active');
    }
  }

  if (window.scrollY < headingDelta) {
    if (homeHeading) {
      homeHeading.classList.remove('active');
    }
  } else if (homeHeading) {
    homeHeading.classList.add('active');
  }
}

function init() {
  window.addEventListener('curtain', () => {
    // Trigger active class on nav
    headerType = document.getElementsByTagName('body')[0].dataset.headerType;
    nav = document.getElementById('navbar');
    navLogo = document.querySelector('.nav-logo');
    universityLinkHeaderFour = document.querySelector('.university-link-header-4');
    universityLink = document.querySelector('.university-link');
    pricingLink = document.querySelector('.pricing-link');
    deltaScreenY = window.innerHeight;
    homeHeading = document.querySelector(`.header-section-${headerType} .js-home-heading`);
    homeCopy = document.querySelector(`.header-section-${headerType} .js-home-copy`);

    // Point at which home copy animates out
    if (headerType === '2' || headerType === '3' || headerType === '5') {
      copyDelta = 0;

      if (homeCopy) {
        homeCopy.style.transition = 'none';
      }
    } else {
      copyDelta = deltaScreenY;
    }

    // Point at which home heading animates out
    if (window.innerWidth <= 1024) {
      headingDelta = window.innerWidth * 0.25;
    } else {
      headingDelta = deltaScreenY + 0.33 * window.innerHeight;
    }
    if (nav) {
      if (window.innerWidth > 1024) {
        window.addEventListener('scroll', () => {
          handleScroll();
        });

        handleScroll();
      }
    }

    if (headerType === '4') {
      const isPageHome = document.body.classList.contains('page-home');
      if (isPageHome) {
        nav.classList.add('js-changes-colour');
      }
      navLogo.classList.add('absolute', 'pl-6', 'lg_pl-10');
      universityLinkHeaderFour.classList.remove('invisible');
    } else {
      navLogo.classList.add('left-1/2', 'transform', '-translate-x-1/2');
      universityLink.classList.remove('invisible');
    }
    const isPageCheckout = document.body.classList.contains('page-checkout');
    if (isPageCheckout) {
      pricingLink.classList.add('md_hidden');
    }
  });
}

(() => {
  init();
})();
